import {NgModule} from '@angular/core';
import { FBPostsComponent } from './fb-posts.component';
import { FBPostsService } from './fb-posts-service';
import {CommonModule} from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';

import {FBPostsRoutingModule} from './fb-posts-routing.module';
import { PerfectScrollbarModule } from 'angular2-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'angular2-perfect-scrollbar';

const PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};
@NgModule({
  declarations: [FBPostsComponent],
  providers: [FBPostsService],
  imports: [CommonModule,BrowserModule, FBPostsRoutingModule, PerfectScrollbarModule.forRoot(PERFECT_SCROLLBAR_CONFIG)],
  exports: [FBPostsComponent]
})
export  class FBPostsModule {
}



// WEBPACK FOOTER //
// ./src/app/facebook-posts/fb-posts.module.ts